import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthenticationModule } from '@fapp/authentication';
import { GraphqlModule } from '@fapp/graphql';

@NgModule({
  declarations: [],
  imports: [CommonModule, GraphqlModule, AuthenticationModule],
})
export class CoreModule {}
